/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import zxcvbn from 'zxcvbn';
import styles from './styles/main.scss';

const propTypes = {
  password: PropTypes.string.isRequired,
};

class PwdStrengthMeter extends React.Component {

  static computeStrength(password) {
    if (!password || password.length === 0) {
      return 0;
    }

    const result = zxcvbn(password);
    const score = result.score;
    if (score === 0 || score === 1) {
      return 1;
    } else if (score === 2 || score === 3) {
      return 2;
    }
    return 3;
  }

  constructor(props) {
    super(props);
    this.state = {
      strength: PwdStrengthMeter.computeStrength(this.props.password),
    };
  }

  componentWillReceiveProps({ password }) {
    this.setState({
      strength: PwdStrengthMeter.computeStrength(password),
    });
  }

  render() {
    return (
      <div styleName="psm">
        <span
          styleName={`psm-block psm-weak ${this.state.strength >= 1 ? 'active' : ''}`}
        />
        <span
          styleName={`psm-block psm-medium ${this.state.strength >= 2 ? 'active' : ''}`}
        />
        <span
          styleName={`psm-block psm-strong ${this.state.strength >= 3 ? 'active' : ''}`}
        />
      </div>
    );
  }
}

PwdStrengthMeter.propTypes = propTypes;

export default CSSModules(PwdStrengthMeter, styles, { allowMultiple: true });




// WEBPACK FOOTER //
// ./src/containers/Register/coms/PwdStrengthMeter/index.jsx